export default __webpack_public_path__ + "static/favicon_2024-3d0ed585e3be4b90f92958eeff7604f4.png";